import '../paedml-modal.tag'
import '../paedml-form-input.tag'
import '../paedml-form-input-pw.tag'

<paedml-modal-edit-password-import>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler} okcondition={okcondition}>
  
    <yield to="fields">

      <div class="paedml-input-group">
        <div class="row">
          <div class="col-sm-6">
            <paedml-form-input name="password" col="9" label="Kennwort" 
              required data-msg="Bitte geben Sie das Kennwort ein"
              data-rule-maxlength="64" data-msg-maxlength="Das Kennwort darf nicht mehr als 64 Zeichen enthalten!" 
              data-rule-minlength={parent.getPasswordLength()} data-msg-minlength="Das Kennwort muss mindestens {parent.getPasswordLength()} Zeichen haben!" 
            />
          </div>
          <div class="col-sm-6">
            <paedml-form-input type="select" name="passwordPolicy" col="7" label="Kennwortoption"
              required values={parent.pwPolicyValues}
            />
          </div>
        </div>
        <div class="row">
         <div class="col-sm-12">
            <paedml-form-input name="externalId" col="10" label="Externe ID" readonly />
          </div>
        </div>
         <virtual if={parent.data.vermerk !== ''}>
          <div class="row">
            <div class="col-sm-12">
             <paedml-form-input name="vermerk" col="12" label="Vermerk" readonly />
            </div>
          </div>
        </virtual>
      </div>

      <div class="paedml-input-group">
       <div class="row">
          <div class="col-sm-12">
              <paedml-form-input name="userName" col="4" label="Benutzername" readonly />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <paedml-form-input name="surname" col="5" label="Nachname" readonly />
          </div>
          <div class="col-sm-6">
            <paedml-form-input name="givenName" col="6" label="Vorname" readonly />
          </div>
        </div>
         <div class="row">
          <div class="col-sm-12">
            <paedml-form-input name="schoolType" col="3" label="Schule" readonly/>
          </div>
        </div>
      </div>

    </yield>
  </paedml-modal>
    
    <script>
      import {autoMapRowToData} from '../../util/modal-util'
      import * as mapper from '../../mapper'
      import Session from '../../store/session'
      import * as R from 'ramda'

      this.userGroup = this.opts.usergroup
      
      this.opname = this.opts.opname
      this.edit = this.opts.edit ? true : false
      this.data = {}
      this.api = this.opts.api
      this.session = Session
      
      this.passwordLength = this.userGroup === 0 ? Session.settings[0]['studentPasswordLength'] : Session.settings[0]['teacherPasswordLength']
 
      this.pwPolicyValues = {
          1: 'Kennwort läuft nie ab',
          2: 'Kennwortänderung erzwingen',
          3: 'Kennwort nicht änderbar'
      }
      
      this.getPasswordLength = () => {
        return this.passwordLength 
      }

      this.on('rowMappingRequested', cols => {

        autoMapRowToData(this, cols)
        this.data.icon = cols[0]
        this.data.id = cols[1]
        this.data.schoolTypeId = cols[2]
        
        this.passwordLength = this.userGroup === 0 ? Session.settings[this.data.schoolTypeId]['studentPasswordLength'] : Session.settings[this.data.schoolTypeId]['teacherPasswordLength']
      })

      this.submitHandler = formData => {
        return this.api.update(formData.ids[0], R.omit(['ids', 'idTexts'], formData))
            .then(rsp => {
              const [data, status] = rsp
              if (status.success) {
                this.parent.trigger('reloadTable')
                return this.opname + ' erfolgreich durchgeführt'
              }

              console.error('error-status', status)
              console.error('error-data', data)
              if (data.message) {
                return Promise.reject(data.message)
              }
              return Promise.reject('Fehler bei ' + this.opname + '!')
            })
      }
    </script>
</paedml-modal-edit-password-import>
